import styled from 'styled-components';

export const Label = styled.label`
  color: ${({ theme }) => theme.colors.mainDarkBlue};
  font-size: 12px;
  line-height: 15px;
  padding-bottom: 5px;
`;
